module.exports = __webpack_public_path__ + "static/media/packages.26ec04f9.png";